import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22font.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./fonts/Kaio-Super.woff2%22,%22preload%22:true}],%22variableName%22:%22HeadlineFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'HeadlineFont', 'HeadlineFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
